/**
 * hl_getCpxCard must have been called.
 *
 * Optional parameters that can be set in 'optionalParameters' parameter:
 *   HTTP proxy:
 *     "s_proxyIpOrUrl"
 *     "i_proxyPort"
 *     "s_proxyLogin"
 *     "s_proxyPassword"
 *  Custom NTP server:
 *     "s_ntpIpOrUrl"
 *     "i_ntpPort"
 *
 * Returns :
 * - s_instanceUniqueId the instance unique ID of the software. The number is unique per user account and do not change
 *                      between restarts or software updates. Not used here for TLSi transactions.
 * - i_connectionHandle the handle of the connection used for TLSi transactions
 *
 * { [...]
 *    "s_instanceUniqueId" : "2.25.186812548863990774547154938929646584355"
 *    "i_connectionHandle" : 262145
 * }
 *
 * @param {string}   pinCode                      E.g. "1234" for all test cards by default.
 * @param {string}   serverFullUrl                TLSi service URL.
 *                                                Set it to an empty string to use the production DMP.
 * @param {number}   transactionsTimeoutInSeconds Transactions timeout.
 * @param {string}   practiceSetting              E.g. "AMBULATOIRE". See spec.
 * @param {number}   cpsPracticeLocationIndice    Practice location to use. Indice in the CPx card list of practices locations.
 * @param {function} resultCallback               The callback that take the result from sendCommand
 */
DMPConnect.prototype.hl_createTlsiConnector = function( pinCode, serverFullUrl, transactionsTimeoutInSeconds, practiceSetting, cpsPracticeLocationIndice, optionalParameters, resultCallback )
{
    var serverUrl = "";

    // Empty string => qualification server.
    if( serverFullUrl === "" )
        serverUrl = "https://qualiflps.services-ps.ameli.fr";
    else
        serverUrl = serverFullUrl;

    var command = {
        "s_commandName"               : "hl_createTlsiConnector",
        "s_tlsiUrl"                   : serverUrl,
        "i_transactionsTimeout"       : transactionsTimeoutInSeconds,
        "s_practiceSetting"           : practiceSetting,
        "i_cpsPracticeLocationIndice" : cpsPracticeLocationIndice,
        "i_getConnectionHandle"       : 1,
        "s_sessionId"                 : this.getSessionId()
    };
    if (pinCode != undefined)
    {
        if (pinCode.length > 0 )
        {
            command.s_pinCode = pinCode;
        }
    }


    // Merge the HTTP proxy parameters and/or the NTP proxy parameters set in optionalParameters.
    if( optionalParameters )
    {
        for( var p in optionalParameters )
        {
            command[ p ] = optionalParameters[ p ];
        }
    }

    // Get connection handle 
    return this.sendCommand( command, 20, resultCallback );
};



/**
 * hl_createTlsiConnector must have been called.
 * 
 * All fields are required, even if they are empty.
 * 
 * IN
 * {
 *     LpsInfos :              // Software-related informations (authorization numbers, etc.)
 *     {
 *        s_idam    [59],      // Software authorization number. From the CNDA.
 *        s_numAM   [ 2],      // IDAM type. Currently must be set to "4" (Authorization number).
 *        s_version [59],      // Software version. No specific format. E.g. "01.00", or "1.0", or "2".
 *        s_instance[59],      // Software instance UUID in its canonical form. See ISO/IEC 9834‐8 et RFC 4122.
 *                             // Must be set, unique and constant per software instance/installation.
 *                             // E.g. "550e8400‐e29b‐41d4‐a716‐446655440000"
 *        s_name    [59]       // The software name.
 *     },
 *     BeneficiaryVitaleData : // Raw Vitale data.
 *     {
 *         s_name     [35],
 *         s_birthName[27],
 *         s_givenName[35],
 *         s_birthday [ 8],    // May be 6 digits-long. May be defined in lunar calendar.
 *         i_rank,
 *         i_qualBenef,
 *         NirData :
 *         {
 *             Nir :
 *             {
 *                 s_nir[13],
 *                 s_key[2]
 *             },
 *             CertifiedNir :
 *             {
 *                 s_nir[13],
 *                 s_key[2]
 *             },
 *             s_certificationDate[8]
 *         },
 *         HealthCoverage :
 *         {
 *             s_regime[2],    // E.g. "01"
 *             s_desk  [3],    // E.g. "349"  a.k.a "Organisme", "Caisse".
 *             s_center[4]     // E.g. "9881" a.k.a "Entité de gestion", "Centre".
 *         }
 *     },
 *     RightsHolderNir :
 *     {
 *         s_nir[13],
 *         s_key[2]
 *     },
 *     s_service,                // For WS-addressing: Action. Service name. E.g. "HR".
 *     s_version,                // For WS-addressing: Action. Its format must be <ref.major.minor>. Eg. "1.1.0".
 *     s_operation,              // For WS-addressing: Action. Operation name. Eg. "ConsulterHistorique"
 *     i_isDevMode               // 0: For production environment. 1: For development environment.
 * }
 * OUT
 * {
 *     s_answerBodyBuffer     : TLSi http request in base64.
 *     s_answerBodyBufferSize : size of the raw data (before beeing base 64 - encoded).
 * }
 * @param {object}   command          Allow to extend the command for optionals parameters
 * @param {function} resultCallback   The callback that take the result from sendCommand
 */
DMPConnect.prototype.hl_generateEmptyTlsiRequestWithRawVitaleData = function( command, resultCallback)
{
    command = command || {};
    command.s_commandName = "hl_generateEmptyTlsiRequestWithRawVitaleData";
    command.s_sessionId   = this.getSessionId();

    return this.sendCommand( command, 15, resultCallback );
};

/**
 * hl_createTlsiConnector must have been called.
 * 
 * All fields are required, even if they are empty.
 *
 * IN 
 * {
 *    LpsInfos :              // Software-related informations (authorization numbers, etc.)
 *     {
 *        s_idam    [59],      // Software authorization number. From the CNDA.
 *        s_numAM   [ 2],      // IDAM type. Currently must be set to "4" (Authorization number).
 *        s_version [59],      // Software version. No specific format. E.g. "01.00", or "1.0", or "2".
 *        s_instance[59],      // Software instance UUID in its canonical form. See ISO/IEC 9834‐8 et RFC 4122.
 *                             // Must be set, unique and constant per software instance/installation.
 *                             // E.g. "550e8400‐e29b‐41d4‐a716‐446655440000"
 *        s_name    [59]       // The software name.
 *     },
 *    s_service,                // For WS-addressing: Action. Service name. E.g. "HR".
 *    s_version,                // For WS-addressing: Action. Its format must be <ref.major.minor>. Eg. "1.1.0".
 *    s_operation,              // For WS-addressing: Action. Operation name. Eg. "ConsulterHistorique"
 *    i_isDevMode               // 0: For production environment. 1: For development environment.
 * }
 * OUT 
 * {
 *     s_answerBodyBuffer     : TLSi http request in base64.
 *     s_answerBodyBufferSize : size of the raw data (before beeing base 64 - encoded).
 * }
 */
DMPConnect.prototype.hl_generateEmptyTlsiRequestWithoutPatientData = function( command, resultCallback )
{
    command = command || {};
    command.s_commandName = "hl_generateEmptyTlsiRequestWithoutPatientData";
    command.s_sessionId   = this.getSessionId();

    return this.sendCommand( command, 15, resultCallback );
};

/**
 * Prerequisites: 
 *  - hl_createDmpConnector must have been called.
 *  - Vitale card must be set.
 * 
 * All fields are required, even if they are empty.
 * 
 * IN
 * {
 *     LpsInfos :              // Software-related informations (authorization numbers, etc.)
 *     {
 *        s_idam    [59],      // Software authorization number. From the CNDA.
 *        s_numAM   [ 2],      // IDAM type. Currently must be set to "4" (Authorization number).
 *        s_version [59],      // Software version. No specific format. E.g. "01.00", or "1.0", or "2".
 *        s_instance[59],      // Software instance UUID in its canonical form. See ISO/IEC 9834‐8 et RFC 4122.
 *                             // Must be set, unique and constant per software instance/installation.
 *                             // E.g. "550e8400‐e29b‐41d4‐a716‐446655440000"
 *        s_name    [59]       // The software name.
 *     },
 *     i_vitalePatientIndex,   // Starting from 0
 *     s_service,              // For WS-addressing: Action. Service name. E.g. "HR".
 *     s_version,              // For WS-addressing: Action. Its format must be <ref.major.minor>. Eg. "1.1.0".
 *     s_operation,            // For WS-addressing: Action. Operation name. Eg. "ConsulterHistorique"
 *     i_isDevMode             // 0: For production environment. 1: For development environment.
 * }
 * OUT
 * {
 *     s_answerBodyBuffer     : TLSi http request in base64.
 *     s_answerBodyBufferSize : size of the raw data (before beeing base 64 - encoded).
 * }
 * @param {object}   command          Allow to extend the command for optionals parameters
 * @param {function} resultCallback   The callback that take the result from sendCommand
 */
DMPConnect.prototype.hl_generateEmptyTlsiRequest = function( command, resultCallback)
{
    command = command || {};
    command.s_commandName = "hl_generateEmptyTlsiRequest";
    command.s_sessionId   = this.getSessionId();

    return this.sendCommand( command, 15, resultCallback );
};

/**
 * Returns information about the ith vitale patient in the vitale card, and technical informations about the Vitale card (serial number, etc.).
 * 
 * The Vitale card must have been read.
 * 
 * IN
 * {
 *     i_vitalePatientIndex,   // Starting from 0
 * }
 *
 * OUT
 * {
 *     PatientData
 *     {
 *         s_name     [35],
 *         s_birthName[27],
 *         s_givenName[35],
 *         s_birthday [ 8],    // May be 6 digits-long. May be defined in lunar calendar.
 *         i_rank,
 *         i_qualBenef,
 *         NirData :
 *         {
 *             Nir :
 *             {
 *                 s_nir[13],
 *                 s_key[2]
 *             },
 *             CertifiedNir :
 *             {
 *                 s_nir[13],
 *                 s_key[2]
 *             },
 *             s_certificationDate[8]
 *         },
 *         HealthCoverage :
 *         {
 *             s_regime[2],    // E.g. "01"
 *             s_desk  [3],    // E.g. "349"  a.k.a "Organisme", "Caisse".
 *             s_center[4]     // E.g. "9881" a.k.a "Entité de gestion", "Centre".
 *         }
 *     },
 *     VitaleData
 *     {
 *         s_cardType       [ 1], // 'R', 'T', 'D': Réelle, Test, Démo.
 *         s_serialNumber   [13], // E.g. "467129252".
 *         s_validityEndDate[ 9]  // E.g. "31122015". May not be defined.
 *     }
 * }
*/
DMPConnect.prototype.hl_getVitaleInfos = function( command, resultCallback)
{
    command = command || {};
    command.s_commandName = "hl_getVitaleInfos";
    command.s_sessionId   = this.getSessionId();

    return this.sendCommand( command, 2, resultCallback );
};

/**
  * @brief Generate an E-Prescription identifier
  *     Identifier is a base32 string.
  * 
  * IN
  * {
  *     
  * }
  * OUT 
  * { 
  *     s_identifier[ 18 ]
  * }
  */
DMPConnect.prototype.hl_generateEPrescriptionIdentifier = function( command, resultCallback )
{
    command = command || {};
    command.s_commandName           = "hl_generateEPrescriptionIdentifier" ;
    command.s_sessionId             = this.getSessionId();

    return this.sendCommand( command, 10, resultCallback );
}
